import { render } from "./SupportTicket.vue?vue&type=template&id=b6a02f8e&scoped=true"
import script from "./SupportTicket.vue?vue&type=script&lang=js"
export * from "./SupportTicket.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-b6a02f8e"

export default script